export default __webpack_public_path__ + "static/media/controller.97beab42.jpg";